import { toast } from 'react-hot-toast';
import { FiCheckCircle, FiAlertCircle, FiInfo } from 'react-icons/fi';

interface SharedToastProps {
  id: number | string;
  message: string;
  type?: 'success' | 'error' | 'info' |  'warning';
  duration?: number;
}

const SharedToast: React.FC<SharedToastProps> = ({ id, message, type = 'info', duration = 3000 }) => {
  const getIconByType = () => {
    switch (type) {
      case 'success':
        return <FiCheckCircle />;
      case 'error':
        return <FiAlertCircle />;
      case 'info':
        return <FiInfo />;
      default:
        return null;
    }
  };


  const getBackgroundColorByType = () => {
    switch (type) {
      case 'success':
        return '#62e793';
      case 'error':
        return '#f87171';
      case 'warning':
        return '#fcd34d';
      case 'info':
        return '#7dd3fc';
      default:
        return '#000';
    }
  };
  
  
  const getColorByType = () => {
    switch (type) {
      case 'success':
        return '#fff';
      case 'error':
        return '#fff';
      case 'info':
        return '#fff';
      case 'warning':
        return '#fff';
      default:
        return '#fff';
    }
  };


  const toastIcon = getIconByType();
  const toastBackgroundColor = getBackgroundColorByType();
  const toastColor = getColorByType()

  // Use the 'id' as part of the 'toast' key to ensure uniqueness
  toast((t) => (
    <div className="flex items-center">
      {toastIcon && <span className="mr-2">{toastIcon}</span>}
      <div>{message}</div>
    </div>
  ), {
    duration,
    id: `toast-${id}`, // Use the 'id' to make the toast unique
    style: {
      backgroundColor: toastBackgroundColor,
      color: toastColor,
    },
    // You can add other options based on your needs
  });

  return null; // This component doesn't render anything in the DOM
};

export const showToast = (options: SharedToastProps) => {
  const { id, message, type, duration } = options;

  // You can customize the options based on your needs
  SharedToast({ id, message, type, duration });
};

export default SharedToast;
